<template>
  <main @scroll="scrollFunc">
    <header class="top">
      <!-- <figure>
        <select name="" id="">
          <option value="订单号">订单号</option>
          <option value="产品名称">产品名称</option>
        </select>
        <input type="text"/>
        <button @click="search.show = true">筛选</button>
      </figure> -->
      <nav>
        <a :class="{on: search.order_client_status === 80}" @click="changeSearch('order_client_status', 80)"><span>全部订单</span></a>
        <a :class="{on: search.order_client_status === 60}" @click="changeSearch('order_client_status', 60)"><span>待支付</span></a>
        <a :class="{on: search.order_client_status === 61}" @click="changeSearch('order_client_status', 61)"><span>已支付</span></a>
        <a :class="{on: search.order_client_status === 90}" @click="changeSearch('order_client_status', 90)"><span>已完成</span></a>
      </nav>
    </header>
    <ul class="list">
      <li v-for="v in list" :key="v.id">
        <header>
          <span>订单号：{{ v.OrderNO }}</span>
          <b>{{v.status}}</b>
        </header>
        <div class="info">
          <p>{{ v.ProductName }}</p>
          <b>{{ v.total_amount }}</b>
        </div>
        <div class="btn">
          <router-link tag="button" :to="{name: 'order_detail', query: { orderNo: v.OrderNO }}">详情</router-link>
          <router-link tag="button" :to="{name: 'pay', query: { orderNo: v.OrderNO, type: 'visa' }}" class="pay" v-show="v.isPaid === 0">支付</router-link>
          <button v-show="search.order_client_status !== 90" class="warn">取消</button>
        </div>
      </li>
      <li><p class="hint">{{ last > search.page  ? '加载中...' : '-我是有底线的-' }}</p></li>
    </ul>
    <section class="dialog" :class="{show: search.show}">
      <div class="box">
        <h3><span>筛选条件</span><i class="icon-close" @click="search.show = false"></i></h3>
        <ul>
          <li>
            <h4>下单时间</h4>
            <div>
              <input placeholder="开始时间" type="date"/>
              <span>-</span>
              <input placeholder="结束时间" type="date"/>
            </div>
          </li>
          <li>
            <h4>选择国家</h4>
            <div>
              <select name="" id="">
                <option value=""></option>
              </select>
            </div>
          </li>
          <li>
            <h4>签证类别</h4>
            <div>
              <select name="" id="">
                <option value=""></option>
              </select>
            </div>
          </li>
          <li>
            <h4>签证形式</h4>
            <div>
              <select name="" id="">
                <option value=""></option>
              </select>
            </div>
          </li>
          <li>
            <h4>手机号码</h4>
            <div>
              <input class="max" type="tel"/>
            </div>
          </li>
          <li>
            <h4>客户名称</h4>
            <div>
              <input class="max" type="text">
            </div>
          </li>
          <li>
            <h4>公司名称</h4>
            <div>
              <input class="max" type="text">
            </div>
          </li>
          <li>
            <h4>公司名称</h4>
            <div>
              <input class="max" type="text">
            </div>
          </li>
          <li>
            <h4>公司名称</h4>
            <div>
              <input class="max" type="text">
            </div>
          </li>
          <li>
            <h4>公司名称</h4>
            <div>
              <input class="max" type="text">
            </div>
          </li>
          <li>
            <h4>公司名称</h4>
            <div>
              <input class="max" type="text">
            </div>
          </li>
          <li>
            <h4>公司名称</h4>
            <div>
              <input class="max" type="text">
            </div>
          </li>
        </ul>
        <div class="btn"><button>重置</button><button>完成</button></div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  data () {
    return {
      search: {
        show: false,
        order_client_status: 80, // 订单状态
        keyword: '', // 关键词
        keyword_type: 0, // 关键词类型
        start_time: '', // 开始时间
        end_time: '', // 结束时间
        Moblie: '', // 手机号
        CustomerName: '', // 客户名称
        company_name: '', // 公司名称
        visaKind: '', // 签证类别
        visaForm: '', // 签证形式
        page: 1,
        page_size: 4
      },
      list: [],
      last: 0,
      getMore: false
    }
  },
  created () {
    const { status = 80 } = this.$route.query;
    this.changeSearch('order_client_status', status);
    this.getList();
  },
  methods: {
    scrollFunc (e) {
      if ( this.getMore || this.search.page >= this.last ) { return; }
      const scrollTop = e.target.scrollTop;
      const windowHeight = e.target.clientHeight;
      const height = document.querySelector('.list').clientHeight + document.querySelector('.top').clientHeight;
      const top = scrollTop + windowHeight - height;
      if ( top >= -10 ) {
        this.getMore = true;
        this.changeSearch('page', this.search.page + 1, false);
      }
    },
    changeSearch (attr, value, clear = true) {
      this.search = { ...this.search, [attr]: value };
      if (clear) {
        this.list = [];
        this.search = { ...this.search, page: 1 }
      }
      this.getList();
    },
    async getList () {
      const { search } = this;
      const params = Object.keys(search).reduce((obj, v) => {
        !!search[v] && (obj[v] = search[v]);
        return obj;
      }, {});
      const { data, last_page } = await this.$axios.get('/VisaOrder/getOrdersByUser', { params });
      this.list = [...this.list, ...data];
      this.last = last_page;
      this.getMore = false;
    }
  }
}
</script>

<style scoped src="./list.css"></style>